import script from "./CalendarCols.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarCols.vue?vue&type=script&setup=true&lang=js"

import "./CalendarCols.vue?vue&type=style&index=0&id=0a908bd6&lang=scss"

const __exports__ = script;

export default __exports__